import {BaseMutation} from '../base-mutation';
import {MessageDescriptor} from '@common/i18n/message-descriptor';
import {editorState} from '@app/editor/state/editor-store';
import {setSelectedContext} from '@app/editor/state/set-selected-context';

/**
 * A mutation reconstructed from persisted history snapshots.
 * Stores before/after full-page HTML and replaces page content on undo/redo.
 */
export class SnapshotMutation extends BaseMutation {
  displayName: MessageDescriptor;
  protected changes: {new: string; old: string};

  constructor(config: {
    pageName: string;
    displayName: MessageDescriptor;
    beforeHtml: string;
    afterHtml: string;
    uniqueId: string;
    createdAt: number;
  }) {
    super('__snapshot__');
    this.displayName = config.displayName;
    this.changes = {new: config.afterHtml, old: config.beforeHtml};
    this.uniqueId = config.uniqueId;
    this.createdAt = config.createdAt;
    // Override pageId: find the page by name and use its runtime id
    const page = editorState().project?.pages.find(
      p => p.name === config.pageName,
    );
    if (page) {
      this.pageId = page.id;
    }
  }

  init(): this {
    return this;
  }

  execute(): boolean {
    return this.applyHtml(this.changes.new);
  }

  undo(): boolean {
    return this.applyHtml(this.changes.old);
  }

  redo(): boolean {
    return this.applyHtml(this.changes.new);
  }

  protected executeMutation(_doc: Document): boolean {
    return true;
  }

  protected undoMutation(_doc: Document): boolean {
    return true;
  }

  private applyHtml(html: string): boolean {
    const pageDoc = this.pageDoc;
    const previewDoc = this.previewDoc;
    if (!pageDoc) return false;

    const docs = previewDoc ? [pageDoc, previewDoc] : [pageDoc];
    for (const doc of docs) {
      doc.documentElement.innerHTML = html;
    }

    // Deselect any selected element since DOM references are stale
    setSelectedContext(null);
    return true;
  }
}
